export default [
    {
        id: '1',
        type: 'article',
        title: 'Breaking: Major Scientific Discovery',
        pretitle: 'SCIENCE',
        author: 'Dr. Elena Rodriguez',
        by_line: 'Science Editor',
        body: '<div><p><strong>CAMBRIDGE, MA</strong> - Researchers at MIT have announced a breakthrough in quantum computing that could revolutionize data processing speeds by a factor of 1000.</p><p>The team, led by Dr. Elena Rodriguez, has successfully demonstrated a new quantum error correction method that maintains coherence for unprecedented durations. "This is the breakthrough we\'ve been waiting for," said Rodriguez during the press conference.</p><p>The implications for artificial intelligence, cryptography, and scientific modeling are enormous. Industry experts predict this could accelerate the timeline for practical quantum computers by at least five years.</p></div>',
        image_url: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&q=80',
        image_caption: 'Quantum computer prototype at MIT laboratory',
        image_name: 'quantum_computer.jpg',
        start_page: 1,
        end_page: 1,
        location_in_start_page: { x: '15.5', y: '8.2' },
        content_metrics: {
            total_number_of_words: 156,
            reading_time_minutes: 1,
        },
    },
    {
        id: '2',
        type: 'article',
        title: 'Climate Summit Reaches Historic Agreement',
        author: 'Michael Chen',
        by_line: 'Environmental Correspondent',
        body: '<div><p>World leaders have finally agreed on binding emissions targets that scientists say could limit global warming to 1.5°C above pre-industrial levels.</p><p>The agreement, signed by 195 nations, includes:</p><ul><li>50% reduction in emissions by 2030</li><li>Net zero by 2050</li><li>$500 billion annual climate fund for developing nations</li></ul><p>"This is our last chance to act," said UN Secretary-General António Guterres. "The world has finally listened to the science."</p></div>',
        start_page: 1,
        end_page: 2,
        location_in_start_page: { x: '52.3', y: '45.8' },
        location_in_end_page: { x: '10.0', y: '5.0' },
        content_metrics: {
            total_number_of_words: 89,
            reading_time_minutes: 1,
        },
    },
    {
        id: '3',
        type: 'image',
        title: 'Global Temperature Anomaly Map',
        image_url: 'https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=800&q=80',
        image_caption: 'NASA visualization showing temperature changes over the past century',
        image_name: 'temperature_map.jpg',
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '25.0', y: '30.0' },
    },
];
